import 'application.sass';
import initAos from './initAos';
//import animateBackground from './animateBackground';
import initMatchHeight from './initMatchHeight';
import initScroll from './initScroll';

$(document).ready(() =>{
  initAos();
  //animateBackground();
  initMatchHeight();
  initScroll();
})



// WEBPACK FOOTER //
// ./source/assets/javascripts/index.js